import { render, staticRenderFns } from "./BeforeAndAfterSwiper.vue?vue&type=template&id=6a31b852&"
import script from "./BeforeAndAfterSwiper.vue?vue&type=script&lang=js&"
export * from "./BeforeAndAfterSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BeforeAndAfterSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports